import React from 'react';
import { Link } from 'react-router-dom';
import './index.css';

type ButtonLinkProps = {
    children?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    fullWidth?: boolean;
    newTab?: boolean;
    onClick?: () => void;
    secondary?: boolean;
    to?: string;
    href?: string;
};

function ButtonLink({
    children,
    className,
    disabled,
    fullWidth,
    newTab,
    onClick,
    secondary,
    to,
    href
}: ButtonLinkProps) {
    if (href) {
        return (
            <a
                className={`
                    buttonLink
                    ${className} 
                    ${fullWidth && 'buttonLink__fullWidth'} 
                    ${secondary && 'buttonLink__secondary'}
                    ${disabled && 'buttonLink__disabled'}
                `}
                target={newTab && '_blank'}
                rel={newTab && 'noopener noreferrer'}
                href={href}
            >
                {children}
            </a>
        )
    }
    
    return (
        <Link
            className={`
                buttonLink
                ${className} 
                ${fullWidth && 'buttonLink__fullWidth'} 
                ${secondary && 'buttonLink__secondary'}
                ${disabled && 'buttonLink__disabled'}
            `}
            to={to}
            onClick={onClick}
        >
            {children}
        </Link>
    );
}

export default ButtonLink;